enum QuestionnaireType {
  YesNo = 'YesNo',
  PassFail = 'PassFail',
  YesNoNA = 'YesNoNA',
}

export default QuestionnaireType
